/**
 * External dependencies
 */
import { BlogPostsIcon } from '~cartzillagb/icons'
import { range } from '~cartzillagb/util'
import {
	disabledBlocks, i18n
} from 'cartzillagb'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks'
import { __ } from '@wordpress/i18n'


export const schema = {
	className : {
		type: 'string',
	},
	enableContainer: {
		type: 'boolean',
		default: true,
	},
	displayTitle: {
		type: 'boolean',
		default: true,
	},
	displayDesc: {
		type: 'boolean',
		default: true,
	},
	displayList: {
		type: 'boolean',
		default: true,
	},
	displayImage: {
		type: 'boolean',
		default: true,
	},
	limit: {
		type: 'number',
		default: 10,
	},
	title : {
		type: 'string',
	},
	subtitle : {
		type: 'string',
	},
	customiconcolor : {
		type: 'string',
	},
	iconcolor : {
		type: 'string',
	},
	mediaURL : {
		type: 'string',
	},
	enableIcon: {
		type: 'boolean',
		default: true,
	},
	
	
}

const maxLimit = applyFilters( 'cartzillagb.info-section-1.edit.inspector.max.limit', 10 )

{ range( 1, maxLimit + 1 ).forEach( i => {

	schema[ `icon${ i }` ] = {
		type: 'string',
		
	}
	schema[ `listitems${ i }` ] = {
        type: 'string',
    }
} ) }



export const name = 'czgb/info-section-1'

export const settings = {
	title: __( 'Info Section #1 Block', i18n ),
	description: __( 'Be creatively informative with Cartzillagb Info Sections.', i18n ),
	icon: BlogPostsIcon,
	category: 'cartzillagb',
	example: {},
	keywords: [
		__( 'Info Section', i18n ),
		__( 'CartzillaGb', i18n ),
	],
	attributes: schema,
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// CartzillaGB modules.
	modules: {
		'advanced-responsive': true,
	},
}